import { useState, type ReactNode } from 'react';

/**
 * A filter row that collapses behind a toggle on phones.
 *
 * Filters are a means to an end, not the content, so on a small screen they fold
 * away behind one row and the list gets the space. On a wide screen they are
 * always visible, exactly as before, so the desktop layout is untouched.
 */
export function FilterBar({
  children,
  activeCount = 0,
  className = '',
}: {
  children: ReactNode;
  /** Shown as a small badge so a folded filter does not hide its own state. */
  activeCount?: number;
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className={className}>
      <button
        type="button"
        className="mb-3 flex w-full items-center justify-between rounded-md border border-surface-border bg-white px-3 py-2.5 text-sm font-semibold text-ink-body transition hover:border-brand md:hidden"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <span>
          Filters
          {activeCount > 0 ? (
            <span className="ml-2 rounded-full bg-brand-soft px-2 py-0.5 text-xs font-bold text-brand-deep">
              {activeCount}
            </span>
          ) : null}
        </span>
        <span className="text-xs font-bold uppercase tracking-wide text-ink-muted">
          {open ? 'Hide' : 'Show'}
        </span>
      </button>
      <div className={`${open ? 'block' : 'hidden'} md:block`}>{children}</div>
    </div>
  );
}
